/**
 * EVO — kiruvchi yuk ekranining URL holati.
 *
 * `lib/finance-search.ts` va `lib/delivery-search.ts` bilan bir xil uchta
 * qoida:
 *   • URL ISHONCHSIZ KIRISH — har maydon tozalanadi (`?page=-5`,
 *     `?status=DROP TABLE` ekranni buzmaydi, default'ga tushadi);
 *   • DEFAULT qiymatlar URL ga YOZILMAYDI — manzil qisqa va ulashsa bo'ladigan;
 *   • oq ro'yxat serverda TAKRORLANMAYDI (`sortBy` bu yerda tekshirilmaydi:
 *     noto'g'ri maydon 400 qaytaradi va jadval xato holatini ko'rsatadi).
 *
 * ============================================================================
 * `status` URL DA BO'LSA — TARIX, BO'LMASA — KUTILAYOTGANLAR
 * ============================================================================
 * Server berilmagan holatni `pending` deb oladi va bu ekranning asosiy ish
 * holati: «menga nima kelyapti?». Shuning uchun `?status=pending` URL ga
 * YOZILMAYDI — u default bilan bir xil ro'yxatni beradi va manzilni bekorga
 * uzaytiradi.
 *
 * `?status=received` va `?status=cancelled` esa YOZILADI: ular ATAYLAB bir
 * qadam narida turadigan tarix va ular havola qilinadi («o'sha yukni qachon
 * qabul qilgan edik?»).
 *
 * ============================================================================
 * `id` — RO'YXAT VA KARTOCHKA BITTA MANZILDA
 * ============================================================================
 * Kartochka ALOHIDA marshrut EMAS (`/supply/incoming/$id` yo'q), balki `?id=`
 * parametri — hisob-faktura va to'lov ekranlaridagi bilan bir xil
 * (`finance-search.ts` dagi ramka). Sabab shu yerda ham amaliy: xabarnoma
 * kartochkasi O'QISH uchun va undan chiqib ketish ro'yxatning holatini
 * (sahifa, tanlangan holat) yo'qotmasligi kerak — ombor xodimi bir necha
 * xabarnomani ketma-ket ochib ko'radi.
 */
import { PARTNER_SUPPLY_STATUSES, type PartnerSupplyStatus } from './partner-supply';
import type { SortDir } from './products';

/** Musbat butun son yoki `undefined` — ID va sahifa uchun umumiy tozalash. */
function positiveInt(value: unknown): number | undefined {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : undefined;
}

export interface PartnerSupplySearch {
  readonly page?: number;
  readonly sortBy?: string;
  readonly sortDir?: SortDir;
  readonly q?: string;
  /** `pending` URL ga yozilmaydi — yuqoridagi izoh. */
  readonly status?: PartnerSupplyStatus;
  /** Ochilgan xabarnoma. Yo'q bo'lsa faqat ro'yxat ko'rinadi. */
  readonly id?: number;
}

export function parsePartnerSupplySearch(
  search: Record<string, unknown>,
): PartnerSupplySearch {
  const page = positiveInt(search.page);
  const id = positiveInt(search.id);

  /*
   * `pending` ATAYLAB tashlab yuboriladi: u default va URL da o'z-o'zini
   * takrorlagan bo'lardi. Qo'lda yozilgan `?status=pending` esa jimgina
   * tozalanadi va ekran o'sha ro'yxatni ko'rsatadi — ya'ni havola
   * ishlaydi, faqat manzil qisqaradi.
   */
  const status =
    typeof search.status === 'string' &&
    search.status !== 'pending' &&
    (PARTNER_SUPPLY_STATUSES as readonly string[]).includes(search.status)
      ? (search.status as PartnerSupplyStatus)
      : undefined;

  return {
    ...(page !== undefined && page > 1 ? { page } : {}),
    ...(typeof search.sortBy === 'string' && search.sortBy !== '' ? { sortBy: search.sortBy } : {}),
    ...(search.sortDir === 'asc' ? { sortDir: 'asc' as SortDir } : {}),
    ...(typeof search.q === 'string' && search.q !== '' ? { q: search.q } : {}),
    ...(status ? { status } : {}),
    ...(id !== undefined ? { id } : {}),
  };
}
